import { InjectionToken } from '@angular/core';

export const ACCORDION_DATA_SOURCE = new InjectionToken('ACCORDION_DATA_SOURCE');
